import { StageDef } from '../automationMachineInterfaces'
import { goToInstagramSettingPageStageDefs } from './goToSettingPageStageDefs'
import { generateToggleStageDefs } from './instagramToggleUtils'
import { hiddenWordsUrl } from './instagramUrls'
import { InstagramSettingKey } from '../../recommendations/recommendationSettingsKeys'
import { InstagramRecommendationKey } from '../../utils/enums'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

const saveKey = InstagramSettingKey.HIDE_MESSAGES
const sectionTitle = 'Hide message requests'
const targetValue = true

const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => (value ? 'On' : 'Off'))
const getIsFulfilledFn = (key) => getIsFulfilledFnFromKey(key, (value) => value)
const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

enum StageKey {
  GATHER_HIDE_MESSAGES = 'GATHER_HIDE_MESSAGES',
  UPDATE_HIDE_MESSAGES = 'UPDATE_HIDE_MESSAGES',
  UNDO_HIDE_MESSAGES = 'UNDO_HIDE_MESSAGES',
}

const {
  gatherStageDefs: gatherToggleStageDefs,
  updateStageDefs: updateToggleStageDefs,
  undoStageDefs: undoToggleStageDefs,
} = generateToggleStageDefs(
  InstagramRecommendationKey.INSTAGRAM_HIDE_MESSAGES,
  [sectionTitle],
  () => saveKey,
  () => targetValue,
  StageKey.GATHER_HIDE_MESSAGES,
  StageKey.UPDATE_HIDE_MESSAGES,
  StageKey.UNDO_HIDE_MESSAGES,
  null, // Null URL. Page navigation is done in previous stages
)

const gatherStageDefs: StageDef[] = [
  ...goToInstagramSettingPageStageDefs(
    StageKey.GATHER_HIDE_MESSAGES,
    'Hidden Words',
    hiddenWordsUrl,
  ),
  ...gatherToggleStageDefs,
]
const updateStageDefs: StageDef[] = [
  ...goToInstagramSettingPageStageDefs(
    StageKey.UPDATE_HIDE_MESSAGES,
    'Hidden Words',
    hiddenWordsUrl,
  ),
  ...updateToggleStageDefs,
]
const undoStageDefs: StageDef[] = [
  ...goToInstagramSettingPageStageDefs(
    StageKey.UNDO_HIDE_MESSAGES,
    'Hidden Words',
    hiddenWordsUrl,
  ),
  ...undoToggleStageDefs,
]

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
